<template>
  <div class="q-mt-lg">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      title="Digite razão social, fantasia ou CNPJ"
      dense
      title-class="text-brand-5 text-weight-bold"
      selection="multiple"
      v-model:selected="selected"
      v-model:pagination="pagination"
      class="q-mt-md"
      row-key="name"
      hide-pagination
      hide-header
      grid
    >
      <template v-slot:top-right>
        <q-input
          rounded
          v-model="filter"
          outlined
          dense
          debounce="300"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:item="props">
        <div
          class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
          :style="selected ? 'transform: scale(0.95);' : ''"
        >
          <q-card :class="selected ? 'bg-grey-2' : ''">
            <q-card-section class="row">
              <q-radio
                dense
                v-model="selected"
                :val="props.row.id"
                :label="props.row.business_name"
              />

              -

              {{ props.row.cnpj }}
            </q-card-section>
            <q-separator />
          </q-card>
        </div>
      </template>
      <template #body-cell-epi="props">
        <q-td>
          <q-btn v-if="props" round color="positive" icon="headphones" />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { computed, onMounted, watch } from "vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();
    const selected = ref([]);
    const rows = ref([]);
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 15,
    });
    const filter = ref("");

    const getEmpresas = async (page = 1) => {
      try {
        const response = await store.dispatch("compras/providerEmpresas", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: 8,
          provider: filter.value,
          search: filter.value,
        });

        rows.value = response.data.results.data;

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getEmpresas);

    const handleRequest = async () => {
      getEmpresas(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => selected.value,
      () => {
        emit("empresa", selected.value);
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getEmpresas();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );
    return {
      selected,
      rows,
      disable,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getEmpresas,
      columns,
      filter,
    };
  },
};
</script>
